module.exports = __webpack_public_path__ + "static/img/prepare_widget_1.61b4bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/prepare_widget_1.png
// module id = Okf1
// module chunks = 11